// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideTrash2 as RawLucideTrash2 } from "lucide-react";
export const LucideTrash2 = /* @__PURE__ */ createIcon(RawLucideTrash2, "LucideTrash2", 2);
